module.exports = __webpack_public_path__ + "GS.png?6e92918ddc09d585e29751f87be7cf71";